<template>
  <div
    class="radiobutton"
    :data-cy="slug"
  >
    <div class="m-form-wrap-elements m-form-wrap-elements--no-padding">
      <div class="m-form-wrap-elements__flex">
        <div
          class="m-form-element m-form-element--no-padding js-m-form-element"
          :class="{'state-m-form-element--input-error': v$[slug] && v$[slug].$error}"
        >
          <fieldset class="m-radiobutton-group m-radiobutton-group--vertical-group">
            <!-- Légende -->
            <legend class="m-radiobutton-group__legend">
              {{ label }}
            </legend>

            <ul class="m-radiobutton-group__list">
              <li
                v-for="option in options"
                :key="option.value"
                class="m-radiobutton-group__item"
              >
                <div
                  data-g-name="RadioButton"
                  class="a-radio-button"
                >
                  <!-- Radio -->
                  <input
                    :id="(id !== '' ? id : slug) + '_' + option.value"
                    type="radio"
                    class="a-radio-button__input js-a-radio-button__input"
                    :name="(id !== '' ? id : slug)"
                    :value="option.value"
                    :checked="model === option.value"
                    @input="$emit(`update:${slug}`, $event.target.value)"
                  >

                  <!-- Label -->
                  <label
                    class="a-radio-button__label"
                    :for="(id !== '' ? id : slug) + '_' + option.value"
                  >
                    <span class="a-radio-button__label-text">{{ option.label }}</span>
                  </label>
                </div>
              </li>
            </ul>
          </fieldset>

          <!-- Message d'erreur -->
          <ErrorMessage :validation-status="v$[slug]" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ErrorMessage from "./ErrorMessage";

export default {
  name: "InputRadio",
  components: {
    ErrorMessage
  },
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    options :{
      type: Array,
      required: true
    },
    v$: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
